import axiosInstance from "../utils/axios";
import {
  ICreateMultiplePurchaseByQuoteData,
  IQuoteByFlightData,
  IQuoteBySurfaceTravelPrivateData,
  IQuoteBySurfaceTravelPublicData
} from "../@interfaces/quote.interface";

const BASE_URL = "/quotes/v1";

export interface IQuoteByCo2Data {
  co2Quantity: number;
  currency: string;
  merchantCode: string;
  paymentProvider: string;
}

async function createQuoteByCo2(data: IQuoteByCo2Data) {
  return axiosInstance.post(`${BASE_URL}/co2`, data, {})
}

async function createQuoteBySurfaceTravelPublic(data: IQuoteBySurfaceTravelPublicData, locale?: string) {
  return axiosInstance.post(`${BASE_URL}/surface-travel/public`, data, {
    params: { locale }
  })
}

async function createQuoteBySurfaceTravelPrivate(data: IQuoteBySurfaceTravelPrivateData, locale?: string) {
  return axiosInstance.post(`${BASE_URL}/surface-travel/private`, data, {
    params: { locale }
  })
}

async function createQuoteByFlight(data: IQuoteByFlightData, locale?: string) {
  return axiosInstance.post(`${BASE_URL}/flight`, data, {
    params: { locale }
  })
}

async function createMultiplePurchaseByQuote(data: ICreateMultiplePurchaseByQuoteData) {
  return axiosInstance.post(`${BASE_URL}/estimates`, data, {})
}

export {
  createQuoteByCo2,
  createQuoteBySurfaceTravelPublic,
  createQuoteBySurfaceTravelPrivate,
  createQuoteByFlight,
  createMultiplePurchaseByQuote,
}